import styled from 'styled-components';

const SearchKeywordSpan = styled.span`
  color: #000;
  font-family: "Avenir Light", "Arial", sans-serif;
  font-size: 15px;
`;

export default SearchKeywordSpan;
